/**
 * Generated from ChooseStoryLayout.fla
 */
export function ChooseStoryLayout(this: IChooseStoryLayout) {
	let main = this.main;
	ChooseStoryLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function ChooseStoryLayout_main(this: IChooseStoryLayout_main) {
	let storyButtons = this.storyButtons;
	if (!storyButtons[0] && storyButtons.elementFactory) {
		storyButtons[0] = storyButtons.elementFactory(0,undefined);
	}
	if (storyButtons[0]) {
		ChooseStoryLayout_buttonStoryBronteSisters.call(storyButtons[0] as IChooseStoryLayout_buttonStoryBronteSisters);
		storyButtons[0].x = -691.8;
		storyButtons[0].y = -461.35;
		storyButtons[0].width = 277.00;
		storyButtons[0].height = 278.00;
		if (storyButtons[0].onLayout) storyButtons[0].onLayout();
	}
	if (!storyButtons[1] && storyButtons.elementFactory) {
		storyButtons[1] = storyButtons.elementFactory(1,undefined);
	}
	if (storyButtons[1]) {
		ChooseStoryLayout_buttonStoryCharlesDickens.call(storyButtons[1] as IChooseStoryLayout_buttonStoryCharlesDickens);
		storyButtons[1].x = 426.6;
		storyButtons[1].y = -463.25;
		storyButtons[1].width = 262.00;
		storyButtons[1].height = 285.00;
		if (storyButtons[1].onLayout) storyButtons[1].onLayout();
	}
	if (!storyButtons[2] && storyButtons.elementFactory) {
		storyButtons[2] = storyButtons.elementFactory(2,undefined);
	}
	if (storyButtons[2]) {
		ChooseStoryLayout_buttonStoryMaryShelley.call(storyButtons[2] as IChooseStoryLayout_buttonStoryMaryShelley);
		storyButtons[2].x = -689.6;
		storyButtons[2].y = -127.25;
		storyButtons[2].width = 276.00;
		storyButtons[2].height = 289.00;
		if (storyButtons[2].onLayout) storyButtons[2].onLayout();
	}
	if (!storyButtons[3] && storyButtons.elementFactory) {
		storyButtons[3] = storyButtons.elementFactory(3,undefined);
	}
	if (storyButtons[3]) {
		ChooseStoryLayout_buttonStoryMayaAngelou.call(storyButtons[3] as IChooseStoryLayout_buttonStoryMayaAngelou);
		storyButtons[3].x = -114.6;
		storyButtons[3].y = -124.8;
		storyButtons[3].width = 259.00;
		storyButtons[3].height = 277.00;
		if (storyButtons[3].onLayout) storyButtons[3].onLayout();
	}
	if (!storyButtons[4] && storyButtons.elementFactory) {
		storyButtons[4] = storyButtons.elementFactory(4,undefined);
	}
	if (storyButtons[4]) {
		ChooseStoryLayout_buttonStoryDrZoom.call(storyButtons[4] as IChooseStoryLayout_buttonStoryDrZoom);
		storyButtons[4].x = 430.8;
		storyButtons[4].y = -126.7;
		storyButtons[4].width = 270.00;
		storyButtons[4].height = 277.00;
		if (storyButtons[4].onLayout) storyButtons[4].onLayout();
	}
	let background = this.background;
	ChooseStoryLayout_background.call(this.background);
	background.x = 0;
	background.y = 262;
	if (background.onLayout) background.onLayout();
	let buttonFreePlayGroup = this.buttonFreePlayGroup;
	ChooseStoryLayout_buttonFreePlayGroup.call(this.buttonFreePlayGroup);
	buttonFreePlayGroup.x = 376.8;
	buttonFreePlayGroup.y = 448.75;
	if (buttonFreePlayGroup.onLayout) buttonFreePlayGroup.onLayout();
	let characterXavier = this.characterXavier;
	ChooseStoryLayout_character.call(this.characterXavier);
	characterXavier.x = -689.5;
	characterXavier.y = 899.2;
	characterXavier.width = 401.10;
	characterXavier.height = 541.05;
	if (characterXavier.onLayout) characterXavier.onLayout();
	let characterYadina = this.characterYadina;
	ChooseStoryLayout_character.call(this.characterYadina);
	characterYadina.x = -159.5;
	characterYadina.y = 877.3;
	characterYadina.width = 401.10;
	characterYadina.height = 541.05;
	if (characterYadina.onLayout) characterYadina.onLayout();
	let characterBrad = this.characterBrad;
	ChooseStoryLayout_character.call(this.characterBrad);
	characterBrad.x = 788.05;
	characterBrad.y = 877.3;
	characterBrad.width = 401.10;
	characterBrad.height = 541.05;
	if (characterBrad.onLayout) characterBrad.onLayout();
	let buttonDragon = this.buttonDragon;
	ChooseStoryLayout_buttonDragon.call(this.buttonDragon);
	buttonDragon.x = -216;
	buttonDragon.y = -342;
	buttonDragon.width = 475.00;
	buttonDragon.height = 181.00;
	if (buttonDragon.onLayout) buttonDragon.onLayout();
	return this;
}
function ChooseStoryLayout_background(this: IChooseStoryLayout_background) {
	let backgroundLowRes = this.backgroundLowRes;
	ChooseStoryLayout_backgroundLowRes.call(this.backgroundLowRes);
	backgroundLowRes.x = 0;
	backgroundLowRes.y = 0;
	backgroundLowRes.width = 8320.00;
	backgroundLowRes.height = 3840.00;
	if (backgroundLowRes.onLayout) backgroundLowRes.onLayout();
	let backgroundBlurred = this.backgroundBlurred;
	ChooseStoryLayout_backgroundBlurred.call(this.backgroundBlurred);
	backgroundBlurred.x = -19.35;
	backgroundBlurred.y = 1265;
	backgroundBlurred.width = 5000.00;
	backgroundBlurred.height = 3000.00;
	if (backgroundBlurred.onLayout) backgroundBlurred.onLayout();
	let yellowLight = this.yellowLight;
	ChooseStoryLayout_yellowLight.call(this.yellowLight);
	yellowLight.x = -1482;
	yellowLight.y = -1030;
	yellowLight.width = 2964.00;
	yellowLight.height = 456.00;
	if (yellowLight.onLayout) yellowLight.onLayout();
	let leftBookshelf = this.leftBookshelf;
	ChooseStoryLayout_leftBookshelf.call(this.leftBookshelf);
	leftBookshelf.x = -2284.85;
	leftBookshelf.y = 934;
	leftBookshelf.width = 2152.00;
	leftBookshelf.height = 2014.00;
	if (leftBookshelf.onLayout) leftBookshelf.onLayout();
	let rightBookshelf = this.rightBookshelf;
	ChooseStoryLayout_rightBookshelf.call(this.rightBookshelf);
	rightBookshelf.x = 2053;
	rightBookshelf.y = 1107.45;
	rightBookshelf.width = 2052.00;
	rightBookshelf.height = 3334.00;
	if (rightBookshelf.onLayout) rightBookshelf.onLayout();
	let mainBookshelf = this.mainBookshelf;
	ChooseStoryLayout_mainBookshelf.call(this.mainBookshelf);
	mainBookshelf.x = 0;
	mainBookshelf.y = 0;
	if (mainBookshelf.onLayout) mainBookshelf.onLayout();
	return this;
}
function ChooseStoryLayout_backgroundLowRes(this: IChooseStoryLayout_backgroundLowRes) {
	if (this.setLayoutTexture) this.setLayoutTexture("storyselect-background@2x.jpg", 0.500, 0.671);
	return this;
}
function ChooseStoryLayout_backgroundBlurred(this: IChooseStoryLayout_backgroundBlurred) {
	if (this.setLayoutTexture) this.setLayoutTexture("storyselect-background-blurred@2x.jpg", 0.500, 1.000);
	return this;
}
function ChooseStoryLayout_yellowLight(this: IChooseStoryLayout_yellowLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("yellow-light.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_leftBookshelf(this: IChooseStoryLayout_leftBookshelf) {
	if (this.setLayoutTexture) this.setLayoutTexture("left-bookshelf.png", 0.500, 1.000);
	return this;
}
function ChooseStoryLayout_rightBookshelf(this: IChooseStoryLayout_rightBookshelf) {
	if (this.setLayoutTexture) this.setLayoutTexture("right-bookshelf.png", 0.500, 1.000);
	return this;
}
function ChooseStoryLayout_mainBookshelf(this: IChooseStoryLayout_mainBookshelf) {
	let stool = this.stool;
	ChooseStoryLayout_stool.call(this.stool);
	stool.x = -1046.8;
	stool.y = -25.25;
	stool.width = 385.00;
	stool.height = 264.00;
	if (stool.onLayout) stool.onLayout();
	let castleBookshelf = this.castleBookshelf;
	ChooseStoryLayout_castleBookshelf.call(this.castleBookshelf);
	castleBookshelf.x = 0;
	castleBookshelf.y = 0;
	castleBookshelf.width = 1936.00;
	castleBookshelf.height = 1259.00;
	if (castleBookshelf.onLayout) castleBookshelf.onLayout();
	return this;
}
function ChooseStoryLayout_stool(this: IChooseStoryLayout_stool) {
	if (this.setLayoutTexture) this.setLayoutTexture("stool.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_castleBookshelf(this: IChooseStoryLayout_castleBookshelf) {
	if (this.setLayoutTexture) this.setLayoutTexture("castle-bookshelf.png", 0.485, 0.751);
	return this;
}
function ChooseStoryLayout_buttonStoryMayaAngelou(this: IChooseStoryLayout_buttonStoryMayaAngelou) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-book-hurston.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonStoryMaryShelley(this: IChooseStoryLayout_buttonStoryMaryShelley) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-book-shelley.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonStoryDrZoom(this: IChooseStoryLayout_buttonStoryDrZoom) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-book-bly.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonStoryCharlesDickens(this: IChooseStoryLayout_buttonStoryCharlesDickens) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-book-dickens.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonStoryBronteSisters(this: IChooseStoryLayout_buttonStoryBronteSisters) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-book-bronte.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonFreePlayGroup(this: IChooseStoryLayout_buttonFreePlayGroup) {
	let buttonFreePlayPillow = this.buttonFreePlayPillow;
	ChooseStoryLayout_buttonFreePlayPillow.call(this.buttonFreePlayPillow);
	buttonFreePlayPillow.x = -339;
	buttonFreePlayPillow.y = -197.8;
	buttonFreePlayPillow.width = 678.00;
	buttonFreePlayPillow.height = 442.00;
	if (buttonFreePlayPillow.onLayout) buttonFreePlayPillow.onLayout();
	let buttonFreePlay = this.buttonFreePlay;
	ChooseStoryLayout_buttonFreePlayAlt.call(this.buttonFreePlay);
	buttonFreePlay.x = -157.5;
	buttonFreePlay.y = -242;
	buttonFreePlay.width = 345.00;
	buttonFreePlay.height = 357.00;
	if (buttonFreePlay.onLayout) buttonFreePlay.onLayout();
	let buttonFreePlayPillowOverlay = this.buttonFreePlayPillowOverlay;
	ChooseStoryLayout_buttonFreePlayPillowOverlay.call(this.buttonFreePlayPillowOverlay);
	buttonFreePlayPillowOverlay.x = -95.5;
	buttonFreePlayPillowOverlay.y = 61.45;
	buttonFreePlayPillowOverlay.width = 277.00;
	buttonFreePlayPillowOverlay.height = 127.00;
	if (buttonFreePlayPillowOverlay.onLayout) buttonFreePlayPillowOverlay.onLayout();
	return this;
}
function ChooseStoryLayout_buttonFreePlayPillow(this: IChooseStoryLayout_buttonFreePlayPillow) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-free-play-pillow.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonFreePlayAlt(this: IChooseStoryLayout_buttonFreePlayAlt) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-story-creator.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_buttonFreePlayPillowOverlay(this: IChooseStoryLayout_buttonFreePlayPillowOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-free-play-pillow-overlay.png", 0.000, 0.000);
	return this;
}
function ChooseStoryLayout_character(this: IChooseStoryLayout_character) {
	return this;
}
function ChooseStoryLayout_buttonDragon(this: IChooseStoryLayout_buttonDragon) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-dragon-orange.png", 0.000, 0.000);
	return this;
}
interface IChooseStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IChooseStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IChooseStoryLayoutSprite extends IChooseStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IChooseStoryLayoutText extends IChooseStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IChooseStoryLayoutPolygon extends IChooseStoryLayoutArray<{x:number,y:number}> {
}
interface IChooseStoryLayout {
	readonly main: IChooseStoryLayout_main;
}
interface IChooseStoryLayout_main extends IChooseStoryLayoutContainer {
	readonly storyButtons: IChooseStoryLayoutArray<IChooseStoryLayout_buttonStoryBronteSisters|IChooseStoryLayout_buttonStoryCharlesDickens|IChooseStoryLayout_buttonStoryMaryShelley|IChooseStoryLayout_buttonStoryMayaAngelou|IChooseStoryLayout_buttonStoryDrZoom>;
	readonly background: IChooseStoryLayout_background;
	readonly buttonFreePlayGroup: IChooseStoryLayout_buttonFreePlayGroup;
	readonly characterXavier: IChooseStoryLayout_character;
	readonly characterYadina: IChooseStoryLayout_character;
	readonly characterBrad: IChooseStoryLayout_character;
	readonly buttonDragon: IChooseStoryLayout_buttonDragon;
}
interface IChooseStoryLayout_background extends IChooseStoryLayoutContainer {
	readonly backgroundLowRes: IChooseStoryLayout_backgroundLowRes;
	readonly backgroundBlurred: IChooseStoryLayout_backgroundBlurred;
	readonly yellowLight: IChooseStoryLayout_yellowLight;
	readonly leftBookshelf: IChooseStoryLayout_leftBookshelf;
	readonly rightBookshelf: IChooseStoryLayout_rightBookshelf;
	readonly mainBookshelf: IChooseStoryLayout_mainBookshelf;
}
interface IChooseStoryLayout_backgroundLowRes extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_backgroundBlurred extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_yellowLight extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_leftBookshelf extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_rightBookshelf extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_mainBookshelf extends IChooseStoryLayoutContainer {
	readonly stool: IChooseStoryLayout_stool;
	readonly castleBookshelf: IChooseStoryLayout_castleBookshelf;
}
interface IChooseStoryLayout_stool extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_castleBookshelf extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonStoryMayaAngelou extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonStoryMaryShelley extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonStoryDrZoom extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonStoryCharlesDickens extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonStoryBronteSisters extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonFreePlayGroup extends IChooseStoryLayoutContainer {
	readonly buttonFreePlayPillow: IChooseStoryLayout_buttonFreePlayPillow;
	readonly buttonFreePlay: IChooseStoryLayout_buttonFreePlayAlt;
	readonly buttonFreePlayPillowOverlay: IChooseStoryLayout_buttonFreePlayPillowOverlay;
}
interface IChooseStoryLayout_buttonFreePlayPillow extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonFreePlayAlt extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_buttonFreePlayPillowOverlay extends IChooseStoryLayoutSprite {
}
interface IChooseStoryLayout_character extends IChooseStoryLayoutContainer {
}
interface IChooseStoryLayout_buttonDragon extends IChooseStoryLayoutSprite {
}
